export default __webpack_public_path__ + "static/media/cameraworld3.2d99caa9.PNG";